import axios from "axios";
import Actions from "common/Actions/Actions";
import { Button } from "common/Button/Button";
import { Input } from "common/Input/Input";
import Modal from "common/Modal/Modal";
import MultiSelect from "common/MultiSelect/MultiSelect";
import { P } from "common/P/P";
import { Select } from "common/Select/Select";
import { SelectItem } from "common/Select/SelectItem";
import Pagination from "components/Pagination/Pagination";
import Timeline from "components/Timeline/Timeline";
import { serviceConfig } from "configs";
import { routeConstants } from "navigation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface IGHTableProps {
	orders: any;
	onRowClick?: (order: any) => void;
	type?: string | any;
	deletable?: boolean;
}

const IGHTable: React.FC<IGHTableProps> = ({
	orders,
	onRowClick,
	type,
	deletable,
}) => {
	const { t } = useTranslation();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isHistoryOpen, setIsHistoryOpen] = useState(false);
	const [sendTargets, setSendTargets] = useState<any>([]);

	const [selectedUserId, setSelectedUserId] = useState("");

	const [selectedUserLabel, setSelectedUserLabel] = useState<any>("");
	const [historyData, setHistoryData] = useState<any[]>([]);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [isChecked, setIsChecked] = useState(false);
	const [isDone, setIsDone] = useState(false);

	const [note, setNote] = useState("");
	const [fileId, setFileId] = useState("");

	console.log("asdsa", selectedUserId);
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user?._id : null; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);

	const openModal = (order?: any) => {
		setFileId(order ? order._id : ""); // Set fileId to order._id if order is provided
		setIsModalOpen(true);
	};
	const closeModal = () => setIsModalOpen(false);

	const openHistory = async (order?: any) => {
		setIsHistoryOpen(true);
		try {
			const response = await axios.post(`${serviceConfig.apiUrl}/history`, {
				letterId: order._id, // Assuming order._id is the letterId
			});
			const data = response.data;
			if (data.success) {
				setHistoryData(data.data); // Store fetched history data
			}
		} catch (error) {
			console.error("Error fetching history:", error);
		}
	};

	const closeHistory = () => setIsHistoryOpen(false);

	const navigate = useNavigate();

	const handleCancelOrder = async (
		event: React.MouseEvent<HTMLButtonElement>,
		order: any
	) => {
		event.stopPropagation();
		// if (order.orderStatus === "Waiting") {
		// 	try {
		// 		const updatedOrder = await orderService.updateUserOrder(
		// 			order.userId,
		// 			order._id,
		// 			{ orderStatus: "Cancelled" }
		// 		);
		// 		window.location.reload();
		// 		// Update the state or re-fetch orders to reflect the changes
		// 	} catch (error) {
		// 		console.error("Error cancelling order:", error);
		// 	}
		// }
	};
	const formatSendTargetsForMultiSelect = (sendTargets: any) => {
		return sendTargets.map((target: any) => ({
			label: `${target.name} ${target.sirname}`,
			value: target._id,
		}));
	};

	useEffect(() => {
		const fetchSendTargets = async () => {
			try {
				const response = await fetch(
					`${serviceConfig.apiUrl}/igh/send-targets/${numericUserTypeId}`
				);
				const data = await response.json();

				let formattedTargets;

				// Conditionally format the targets if user type ID is 6
				if (numericUserTypeId === 6) {
					formattedTargets = formatSendTargetsForMultiSelect(data.data);
				} else {
					// Use the data directly if the user type ID is not 6
					formattedTargets = data.data;
				}

				setSendTargets(formattedTargets); // Update with formatted data
			} catch (error) {
				console.error("Error fetching send targets:", error);
			}
		};

		fetchSendTargets();
	}, [numericUserTypeId]);

	const handleSelect = (userId: string) => {
		setSelectedUserId(userId);
		const selectedUser = sendTargets.find((user: any) => user._id === userId);
		if (selectedUser) {
			setSelectedUserLabel(`${selectedUser.name} ${selectedUser.sirname}`);
		}
	};

	const handleMultiSelect = (selectedValues: any) => {
		// selectedValues should be an array of the selected options' values
		setSelectedUsers(selectedValues);
	};

	const handleSendLetter = async () => {
		let endpoint = "";
		const userString = localStorage.getItem("user");
		const user = userString ? JSON.parse(userString) : null;

		const userId = user ? user?.user._id : ""; // Replace with actual user ID

		switch (type) {
			case "igh":
				endpoint = `${serviceConfig.apiUrl}/igh/send-letter`;
				break;
			case "iih":
				endpoint = `${serviceConfig.apiUrl}/iih/send-letter`;
				break;
			// Add more cases as needed
		}

		if (endpoint) {
			try {
				const payload: any = {
					sentNumber: fileId,
					currentUserId: userId,
					sendingUserIds:
						numericUserTypeId === 6 ? selectedUsers : selectedUserId,
					letterType: type === "igh" ? "IGH" : type === "iih" ? "IIH" : "IGH",
					note: note,
					checked: isDone,
				};

				if (isChecked) {
					payload.status = "Arhiwda";
				}

				if (isDone) {
					payload.checked = true;
				}

				const response = await axios.post(endpoint, payload);

				const data = response.data;

				if (data.success) {
					setFileId("");
					setSelectedUserId("");
					closeModal();
					window.location.reload();
				} else {
					console.error("Failed to send letter:", data.message);
				}
			} catch (error: any) {
				console.error(
					"Error sending letter:",
					error.response ? error.response.data : error
				);
			}
		}
	};

	const handleViewDocument = (order: any) => {
		navigate(
			`${routeConstants.seeDocument.route}?type=${type}&id=${order._id}`
		);
	};

	const handleCheckboxChange = (e: any) => {
		setIsChecked(e.target.checked);
	};
	const handleCheckboxDoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setIsDone(e.target.checked);
	};

	const handleDeleteLetter = async (letter: any) => {
		// Confirmation dialog or additional UI logic here
		try {
			const response = await axios.delete(
				`${serviceConfig.apiUrl}/${type}/${letter._id}`
			);
			if (response.data.success) {
				window.location.reload();
			} else {
				// Handle deletion failure
			}
		} catch (error) {
			console.error("Error deleting order:", error);
			// Show error message or handle error
		}
	};
	return (
		<>
			<table className="w-full border rounded-lg border-strokeColor">
				<thead className="bg-white border border-strokeColor">
					<tr className="bg-bgColor">
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Hatyň görnüşi
							</P>
						</th>
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Senesi
							</P>
						</th>
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Bellik
							</P>
						</th>
						<th className="w-16 px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Amallar
							</P>
						</th>
					</tr>
				</thead>
				<tbody className="text-left">
					{orders.map((order: any, idx: any) => (
						<tr
							key={order._id + idx}
							className={`${
								idx === orders.length - 1
									? "border-0"
									: "border-b border-strokeColor"
							} ${
								order.expired && order.expired
									? "bg-[#ffdfdf]"
									: idx % 2 === 0
									? "bg-white"
									: "bg-[#f9f9f9]"
							}`}
							onClick={() => onRowClick && onRowClick(order)}
						>
							<td
								className={`px-5 py-[18px] text-textColor font-medium ${
									idx === orders.length - 1 ? "" : ""
								}`}
							>
								<P size="p3" type="light">
									{order.status === "Familiarization"
										? "Tanyşdyryş"
										: order.status === "Execution"
										? "Ýerine ýetirmek"
										: ""}
								</P>
							</td>
							<td className="px-5 py-[18px] font-medium text-textColor">
								<P size="p3" type="light">
									{new Date(order.sentDate)
										.toLocaleDateString("en-GB", {
											day: "2-digit",
											month: "2-digit",
											year: "numeric",
										})
										.replace(/\//g, ".")}
								</P>
							</td>

							<td
								className={`px-5 py-[18px] text-textColor font-regular ${
									idx === orders.length - 1 ? "" : ""
								}`}
							>
								<P size="p3" type="light">
									{order.note}
								</P>
							</td>

							<td className="px-5 py-[18px]">
								<Actions
									onView={() => handleViewDocument(order)}
									{...(deletable
										? {
												onDelete: () => handleDeleteLetter(order),
										  }
										: {
												onSend: () => openModal(order),
										  })}
									onHistory={() => openHistory(order)}
								/>
							</td>
						</tr>
					))}
					<Modal
						isOpen={isModalOpen}
						onClose={closeModal}
						title="Ibermek"
						width="w-[600px]"
					>
						<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
							<div className="grid grid-cols-1">
								<Input
									appearance="default"
									type="text"
									name="fileId"
									withlabel={true}
									label="Faýl Id"
									value={fileId}
									disabled
								/>
							</div>

							<div className="grid grid-cols-1">
								{numericUserTypeId === 6 ? (
									<MultiSelect
										label="Kabul ediji"
										options={sendTargets} // Assuming fileOptions is fetched from your API
										onSelect={handleMultiSelect}
									/>
								) : (
									<Select
										label="Kabul ediji"
										onSelect={handleSelect}
										defaultSelectLabel="Ulanyjy saýlaň"
										value={selectedUserLabel} // Display the selected user's name and surname
									>
										{sendTargets.map((user: any) => (
											<SelectItem key={user._id} value={user._id}>
												{user.name} {user.sirname}
											</SelectItem>
										))}
									</Select>
								)}
							</div>

							<div className="grid grid-cols-1">
								<Input
									appearance="default"
									type="text"
									name="note"
									withlabel={true}
									label="Bellik"
									value={note}
									onChange={(e) => setNote(e.target.value)}
								/>
							</div>
							<div className="grid gap-2 grid-cols-maxTwo place-items-center">
								{numericUserTypeId === 6 ? (
									<div className="grid gap-2 grid-cols-maxTwo place-items-center">
										<input
											type="checkbox"
											checked={isChecked}
											onChange={handleCheckboxChange}
										/>
										<P size="t1" type="medium">
											Haty Ýapmak
										</P>
									</div>
								) : (
									<>
										<input
											type="checkbox"
											checked={isDone}
											onChange={handleCheckboxDoneChange}
										/>
										<P size="t1" type="medium">
											Barlandy
										</P>
									</>
								)}
							</div>
							<Button
								appearance="main"
								className="place-self-center"
								paddingX="px-12"
								paddingY="py-[10px]"
								onClick={handleSendLetter}
							>
								Ibermek
							</Button>
						</div>
					</Modal>

					<Modal
						isOpen={isHistoryOpen}
						onClose={closeHistory}
						title="Hereketiň taryhy"
						width="w-[862px]"
						scroll={true}
					>
						<Timeline historyData={historyData} />
					</Modal>
				</tbody>
			</table>
		</>
	);
};

export default IGHTable;
